import React, { memo } from 'react';
import { HERO_CONFIG } from '../config/constants';

const { FALLBACK_IMAGES } = HERO_CONFIG;

const FallbackImageSlider = ({ heroState, isSlowConnection, show }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-20">
      {FALLBACK_IMAGES.map((imageSrc, index) => {
        const isActive = index === heroState.fallbackImageIndex;

        return (
          <img
            key={imageSrc}
            src={imageSrc}
            alt={`Hero background ${index + 1}`}
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
            style={{
              opacity: isActive ? 1 : 0,
              transformOrigin: 'center center',
              transform: isActive ? 'scale(1.1)' : 'scale(1.0)',
              animation: isActive
                ? 'heroImageZoom 10s linear forwards'
                : 'none',
              zIndex: isActive ? 2 : 1,
            }}
          />
        );
      })}
    </div>
  );
};

export default memo(FallbackImageSlider);
